// エラーメッセージ定義
const stripeErrorMessages = {
    // カードエラー
    card_declined:  'このカードはご利用いただけません。別のカードをお試しください。',
    expired_card: 'カードの有効期限が切れています。',
    invalid_number: 'カード番号が不正です。再度入力するか、別のカードをご利用ください',
    invalid_expiry_month: 'カードの有効期限(月)が誤っています。',
    invalid_expiry_year: 'カードの有効期限(年)が誤っています。',
    invalid_cvc: 'セキュリティーコードが誤っています。',
    insufficient_funds: 'カードの残高が不足しています。別のカードをお試しください。',
    processing_error: '処理中にエラーが発生しました。再度入力するか、別のカードをご利用ください。',
    incorrect_zip: 'カードの郵便番号が誤っています。再度入力するか、別のカードをご利用ください。',
    incorrect_address: 'カードの住所情報が誤っています。再度入力するか、別のカードをご利用ください。',
    incorrect_cvc: 'カードのセキュリティーコードが誤っています。再度入力するか、別のカードをご利用ください。',
    incorrect_number: 'カード番号が誤っています。再度入力するか、別のカードをご利用ください。',

    invalid_request_error: 'このカードは現在使用できない可能性があります。登録カードをご確認いただくか別のカードをお試しください。',
    api_connection_error: '通信エラーが発生しました。しばらくしてから再試行してください。',
    api_error: '処理中にエラー発生しました。しばらくしてから再試行してください。',

    default: {
      confirm_card_payment: 'カード決済ができませんでした。',
      confirm_card_setup: '支払い方法の設定ができませんでした。',
      unexpected: 'エラーが発生しました。時間をおいて再試行してください。',
    }
};

/**
 * Stripeのエラーメッセージを取得する関数
 * @param {Object} error - Stripeのエラーオブジェクト
 * @returns {string} - エラーメッセージ
 */
const getStripeErrorMessage = (error) => {
  // error オブジェクトの存在確認
  if (!error || typeof error !== "object") {
    return stripeErrorMessages.default.unexpected;
  }

  // エラーメッセージを取得（error.code があれば優先）
  if (stripeErrorMessages[error.code]) return stripeErrorMessages[error.code];
  if (stripeErrorMessages[error.type]) return stripeErrorMessages[error.type];
  
  // エラーメッセージの定義がない場合は error.message を使用
  if (error.message) {
    return error.message;
  }

  // 実行された処理を判定（confirmCardPayment or confirmCardSetup）
  const isPayment = !!error.payment_intent;
  const isSetup = !!error.setup_intent;

  // error.messageが未設定ならデフォルトメッセージ
  if (isPayment) return stripeErrorMessages.default.confirm_card_payment;
  if (isSetup) return stripeErrorMessages.default.confirm_card_setup;

  return stripeErrorMessages.default.unexpected;
};

export { stripeErrorMessages, getStripeErrorMessage };
